import React from 'react'
import PropTypes from 'prop-types'

export const CurrencyDetails = ({ currencyRate: {
	quantity, conversion_value, inverse_conversion_value
} }) => {
	return <div>
		<p className='u-margin-none'><span className='u-weight--semi-bold'>За единици валута:</span> { quantity }</p>
		<p className='u-margin-none'><span className='u-weight--semi-bold'>Курс (BGN):</span> { conversion_value }</p>
		<p className='u-margin-none'><span className='u-weight--semi-bold'>Обърнат курс:</span> { inverse_conversion_value }</p>
	</div>
}

CurrencyDetails.propTypes = {
	currencyRate: PropTypes.shape({
		quantity: PropTypes.number,
		conversion_value: PropTypes.number,
		inverse_conversion_value: PropTypes.number
	})
}

export default CurrencyDetails
